import React from "react";
import CreateInforms from "../../views/adminView/informs";

export default function InformsPage() {
    return <CreateInforms />
}